import React 				from 'react';
import PropTypes 			from 'prop-types';
import BLComponent			from '../core/_BLComponent.jsx';
import PillStatus 			from '../common/_PillStatus.jsx';
import MultilineEllipsis from '../common/_MultilineEllipsis.jsx';

//this.props.classes	: string of classes

/*this.props.data 		: {
	  image: string of image url
	, name: string of product name
	, link: string of link
	, price: (optional) integer of price
}*/

/*this.props.wantedList	: (optional) {
															enabled 			: boolean
														,	isWanted 			: boolean
														, wantedCount 	: integer of how many times appears on wanted lists
													}*/

//this.props.status				: (optional) integer of status from 0 to 5 
//this.props.remainingQty	: (optional) integer of qty remaining, not optional if pillType is 0

export default class ProductCard extends BLComponent 
{
	constructor( props ) 
	{
		super(props);

		this.state = 
		{
			wantedListEnabled:	( props.wantedList && props.wantedList.enabled )
		,	qtyCheckEnabled: 	( props.qtyCheckEnabled )
		,	isWanted:			( props.wantedList && props.wantedList.isWanted )
		,	wantedCnt:			( props.wantedList && props.wantedList.wantedCount ) ? props.wantedList.wantedCount : 0
		,	limitedAvailable:	false
		}

		this._callbackRegistered	= null;
	}

	static getDerivedStateFromProps( nextProps, prevState ) 
	{
		prevState.wantedListEnabled	= ( nextProps.wantedList && nextProps.wantedList.enabled );
		prevState.qtyCheckEnabled	= nextProps.qtyCheckEnabled;
		prevState.limitedAvailable	= nextProps.limitedAvailable == true ? true : false;

		return prevState;
	}	

	componentDidMount() 
	{
		this.fetchPersonalizeData();
	}

	componentWillUnmount() 
	{ 
		super.componentWillUnmount(); 
		if ( this._callbackRegistered != null )
			blapp.personalized.unregisterCallback( this._callbackRegistered );
	}

	componentDidUpdate( prevProps, prevState, snapshot ) 
	{ 
		super.componentDidUpdate( prevProps, prevState, snapshot ); 

		if ( ( prevState.wantedListEnabled != this.state.wantedListEnabled
				|| prevState.qtyCheckEnabled != this.state.qtyCheckEnabled
				|| prevProps.data.idItem != this.props.data.idItem
				|| prevProps.data.idColor != this.props.data.idColor )
			&& ( this.state.wantedListEnabled || this.state.qtyCheckEnabled ) )
		{
			blapp.personalized.fetchWantedPrefData( this.props.data.idItem, this.props.data.idColor, this.updatePersonalizedData );
		}
	}	

	render() 
	{
		const {classes = '', remainingQty = null, titleLineCnt} = this.props;
		const {link, image, name, price = null, breadcrumbs, author = false, desc = false} = this.props.data;

		const wantedListEnabled 	= this.state.wantedListEnabled;
		const wantedListIsWanted 	= this.state.isWanted;
		const wantedListCount 		= this.state.wantedCnt;

		let breadcrumbItems;

		if(breadcrumbs) {
			breadcrumbItems = breadcrumbs.map((crumb, key) => <li className="l-inline-block" key={key}><a className="text--inherit" href={crumb.link}>{crumb.content}{key < breadcrumbs.length - 1 && <i className="fas fa-chevron-right l-margin-x--xs l-inline-block text--small text-color--grey"/>}</a></li>);
		}
			
		return (
			<article className={"card " + classes}>
				<div className={"card__internal product-card"}>
					<a href={link} className="product-card__main">
						<div className="product-card__image">
							<div className="product-card__image-internal">
								<img className="product-card__image-item" src={image}/>
							</div>
						</div>
						{breadcrumbs ? 
							<ul className="overflow-ellipsis text--small">{breadcrumbItems}</ul>
						: null}
						<strong className="product-card__title" title={name}>
							{name}
						</strong>
						{this.state.limitedAvailable ? <p className="text-color--primaryRed">{$T( "ALMOST_GONE" )}</p> : (price ? ( price >= 0 ? <strong>{`${blapp.format.formatMoney(price)}+`}</strong> : "") : "")}
						{author ? 
							<div className="product-card__user text--small">
								<div className="product-card__user-image">
									<img src={author.image}/>
								</div>
								<p>{author.name}</p>
							</div> 
						: null}
						{desc ? 
							<p className="product-card__description">{desc}</p>
						: null}
					</a>
					{wantedListEnabled || this.state.limitedAvailable ? 
						<div className="product-card__meta">
							{wantedListEnabled ?
								<div className="product-card__action product-card__wanted-list">
									<button className="btn btn--blank text--no-wrap" onClick={() => this.toggleAddWantedList()}>
										<i className={"product-card__wanted-icon l-margin-right--xxs " + (wantedListIsWanted ? "fas fa-heart" : "far fa-heart") + (wantedListIsWanted ? " product-card__wanted-icon--active" : "")}></i>
										{wantedListCount}
									</button>
								</div>
							: null}
						</div>
					: null}
				</div>
			</article>
		);
	}

	toggleAddWantedList = () =>
	{
		if ( this.state.wantedListEnabled )
		{
			const	srcMap 	= 	_.assign( 
									{ location: blapp.srcmap.LOCATION.GENERAL_XP, typeSrcFrom: blapp.srcmap.SRCTYPE.CATALOG_ITEM, idSrcFrom: this.props.wantedList.dmItemView.dmItem.idItem }
								,	this.props.wantedList && this.props.wantedList.srcMap ? this.props.wantedList.srcMap : {}
								);

			blapp.wanted.showAddWantedListModal
			(
				this.props.wantedList.dmItemView
			,	() => { this.fetchPersonalizeData(); }
			,	srcMap
			);
		}
	}

	fetchPersonalizeData()
	{
		if ( ( this.state.wantedListEnabled || this.state.qtyCheckEnabled ) && this.props.data.idItem )
		{
			this._callbackRegistered	= this.updatePersonalizedData;
			blapp.personalized.fetchPersonalizedData( this.props.data.idItem, this.props.data.idColor, this.updatePersonalizedData, this.state.wantedListEnabled, this.state.qtyCheckEnabled );
		}
	}

	updatePersonalizedData = ( data ) => 
	{
		if ( data && data.dataWantedPref )
		{
			this.setState( { isWanted: data.dataWantedPref.bIsWanted, wantedCnt: data.dataWantedPref.nWantedUserCnt } );
		}

		if ( data && data.dataRemainQty )
		{
			this.setState( { limitedAvailable: ( data.dataRemainQty.nRemainQtyIC > 0 && data.dataRemainQty.nRemainQtyIC <= 5 ) ? true : false } );
		}
	}

	static getDataFromBLMColletionItem( item )
	{
		return	{
					image:		item.urlCustomImg || blapp.url2.getCatalogItemImgUrl( item.dmItemView.dmImg )
				,	name:		item.dmItemView.dmItem.strItemName
				,	itemNo: 	item.dmItemView.dmItem.strItemNoFull
				,	link: 		blapp.url2.getCatalogItemPageUrl(item.dmItemView.dmItem, item.dmItemView.idColor)
				,	idItem:		item.dmItemView.dmItem.idItem
				,	idColor:	item.dmItemView.idColor
				}
	}

	static getDataFromBLMCatalogItemWithColor( item, imgSize )
	{
		return 	{
					image:		blapp.url2.getCatalogItemImgUrl( item.dmImg, imgSize )
				,	name:		item.dmItem.strItemName
				,	itemNo:		item.dmItem.strItemNoFull
				,	link:		blapp.url2.getCatalogItemPageUrl(item.dmItem, item.idColor)
				,	idItem:		item.dmItem.idItem
				,	idColor:	item.idColor
				};
	}

	static getDataFromModelCrowd( dmModel )
	{
		const	dmBasic	= dmModel.dmBasic;
		const	mainImg	= !_.isEmpty( dmModel.arrImgs ) ? dmModel.arrImgs[ 0 ].main.strUrl : blapp.url2.getUrlFromFileInfo( dmBasic.dmMainImage );

		return	{
					id:				dmBasic.idModel
				,	image:			mainImg
				,	name:			dmModel.strName || dmBasic.strModelName
				,	desc:			dmModel.strDescriptionShort
				// ,	price:			dmModel.mInvMinPrice ? dmModel.mInvMinPrice : -1
				,	author:			{
										name:	dmBasic.dmUserBuilder.dmUser.skUsername
									,	id:		dmBasic.dmUserBuilder.dmUser.idUser
									,	image:	blapp.url2.getProfileImgUrl( dmBasic.dmUserBuilder.dmUser, "medium" )
									}
				,	link:			blapp.url2.getCrowdProjectDesignViewUrl( dmBasic.idModel, dmModel )
				,	idItem:			dmModel.dmCatItem ? dmModel.dmCatItem.dmItem.idItem : null
				};
	}

	static getWantedListEnableInfo( dmItemView, srcMap )
	{
		return 	{
					enabled: 		true
				,	isWanted:		false
				,	wantedCount: 	0
				,	dmItemView:		dmItemView
				,	srcMap:			srcMap
				};
	}
}

var $T = BLComponent.createTextMap(
	{
		"ALMOST_GONE":
		{
			"en":	"Almost gone"
		,	"kr":	"품절 임박"
		,	"es":	"Últimas unidades"
		}
	},
	{
		"NO_LISTINGS_YET":
		{
			"en":	"No listings yet"
		,	"kr":	""
		,	"es":	""
		}
	}
);

ProductCard.propTypes = 
	{
		classes:			PropTypes.string
	,	titleLineCnt: 		PropTypes.oneOf([2, 3, 4, 5])
	,	data: 				PropTypes.shape(
								{
					  				image:		PropTypes.string.isRequired
								,	name:		PropTypes.string.isRequired
								,	link:		PropTypes.string.isRequired
								,	price:		PropTypes.number
								,	idItem:		PropTypes.number
								,	idColor:	PropTypes.number
								,	breadcrumbs: PropTypes.arrayOf(PropTypes.shape({link: PropTypes.string, content: PropTypes.string}))
								,	author:		PropTypes.shape({
														name: 	PropTypes.string.isRequired
													,	id: 	PropTypes.number.isRequired
													,	image: 	PropTypes.string.isRequired
												})
								,	desc: 		PropTypes.string
								}
							).isRequired
	,	wantedList:			PropTypes.shape(
								{
									enabled:		PropTypes.bool
								,	isWanted:		PropTypes.bool
								,	wantedCount:	PropTypes.number
								,	dmItemView:		PropTypes.object
								,	srcMap:			PropTypes.object
								}
							)
	,	qtyCheckEnabled:	PropTypes.bool
	,	limitedAvailable:	PropTypes.bool
	,	remainingQty:		function (props, propName, componentName ) 
							{
								if ( props['status'] === 0 && props[propName] == undefined ) 
									return new Error('You must provide a remainingQty when having a status of 0')
							}
}